export default "__VITE_PUBLIC_ASSET__52c3d7b7__"